import { createContext } from 'react'

const BalanceContext = createContext<BalanceContextType>([0, () => {}])

export default BalanceContext

type BalanceContextType = [number, (value: ((prev: number) => number) | number) => void]